import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"];
import { useContext } from 'react';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedSize(_ref) {
  let {
      value
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  return /*#__PURE__*/_jsx("span", {
    children: I18n.formatSize(value, options)
  });
}
FormattedSize.displayName = 'FormattedSize';
export default FormattedSize;